import { _ as _await_value } from "./_await_value.js";

function _await_async_generator(value) {
    return new _await_value(value);
}
export { _await_async_generator as _ };
